<template>
	<span>{{ readable }}</span>
</template>

<script>
	export default {
		name: "date-span",
		props: { date: { required: true, type: String }, format: { type: String, default: "d-M-Y" }, onlyTime: Boolean },
		computed: {
			readable () {
				let date = this.date;
				if (this.onlyTime) {
					date = "1970-01-01T" + this.date;
				}
				return moment(date).format(this.format);
			},
		},
	};
</script>

<style scoped>

</style>
